module.exports = __webpack_public_path__ + "static/img/13441631515546.5fa7b25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/13441631515546.jpg
// module id = l3Ws
// module chunks = 0